/**
 * The designed absence of a route the running platform does not publish yet — an information
 * line, not an error (`not-published.ts`, `docs/adr/6004`, the shape of `docs/adr/9016`'s band).
 *
 * Drawn by the shared `NotPublishedLine` (`docs/adr/9033`), so that on a page that draws one
 * status strip the sentence is said there once rather than in the panel.
 */

import { NotPublishedLine } from '@/planning';

export function NotPublishedNote({ bodyKey }: { readonly bodyKey: string }): React.JSX.Element | null {
  return <NotPublishedLine bodyKey={bodyKey} />;
}
